import { Box, BoxProps, styled } from "@mui/material"
import { CellContentPosition, TableVariants } from "../interfaces"

type TableCellComponentProps = BoxProps & {
    variant?: TableVariants
    colCount?: number
    alignContent?: CellContentPosition
    textColor?: string
    className?: string
    /* The property font size can be used to provide number of pixels */
    fontSize?: number
    rowIndicatorWidth?: number
    borderOnlyOnTheLeft?: boolean
}

function shouldForwardProp(prop: PropertyKey) {
    return !["colCount", "alignContent", "variant", "maxWidth", "rowIndicatorWidth", "rowIndicatorColor", "fontSize", "textColor"].includes(
        prop as string
    )
}

export const TableCellComponent = styled(Box, { shouldForwardProp })<TableCellComponentProps>((props) => {
    const { theme, alignContent, variant, textColor, className, fontSize } = props

    return {
        ...theme.typography.label,
        ...(textColor && {
            color: textColor,
        }),
        opacity: undefined,
        zIndex: 1,
        className,
        display: "flex",
        alignItems: "center",
        justifyContent: alignContent ?? "start",
        padding: variant === "small" ? theme.spacing(0.25, 0.5) : theme.spacing(1),
        fontSize: 14,

        ...(variant === "small" && {
            fontSize: `${fontSize ?? 12}px`,
            "*": {
                fontSize: "12px",
                lineHeight: "1.2",
            },
        }),
        ...(fontSize !== undefined && {
            fontSize: `${fontSize ?? 14}px`,
            "*": {
                fontSize: `${fontSize ?? 14}px`,
            },
        }),
    }
})
